// Constants to make page navigation in code more readable

export const LANDING = '/';


// Added Pages
export const ABOUT = '/about';
export const INITIATIVES = '/initiatives';
export const EBOARD = '/eboard';
export const CONTACT = '/contact';
export const SPONSORS = '/sponsors';
export const SHOP = '/merch_shop';

export const GENERAL_MEETINGS = '/gm';
export const COPA_DEL_SOL = '/copa-del-sol';
export const COPA_ABOUT = '/copa-del-sol/about';
export const COPA_TOURNAMENTS = '/copa-del-sol/tournaments';
export const COPA_GUIDELINES = '/copa-del-sol/guidelines';
export const COPA_SPONSORS = '/copa-del-sol/sponsors';
export const COPA_CONTACT = '/copa-del-sol/contact';
export const PROJECTS = '/projects';

// Tutoring Pages
export const TUTORING = '/tutoring';
export const TUTOR = '/tutor';
export const TUTORING_STUDENT = '/tutoring_student'


